<kendo-tilelayout [columns]="3" [resizable]="false" [reorderable]="false">
  <kendo-tilelayout-item [col]="1" [row]="1" [rowSpan]="1" class="kpi-1"
    *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)">
    <kendo-tilelayout-item-body
      *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)">
      <div class="upcoming-kpis">Upcoming KPI</div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
  <kendo-tilelayout-item [col]="2" [row]="1" [rowSpan]="1" class="kpi-2"
    *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)"><kendo-tilelayout-item-body>
      <div class="upcoming-kpis">Upcoming KPI</div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
  <kendo-tilelayout-item [col]="3" [row]="1" [rowSpan]="1" class="kpi-3"
    *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)">
    <kendo-tilelayout-item-body>
      <div class="upcoming-kpis">Upcoming KPI</div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
  <kendo-tilelayout-item [col]="1" [row]="gridApiRoute === gridRoutes.eiTransition ? 1 : 2" [colSpan]="3" [rowSpan]="6">
    <kendo-tilelayout-item-header [title]="title" class="dashboard-header">
      <h1 class="dashboard-title">
        {{ title }}
      </h1>
    </kendo-tilelayout-item-header>
    <kendo-tilelayout-item-body style="overflow-y: scroll;"> <!-- TODO @sandesh -->
      <app-grid [columnDefinitions]="columnDefinitions" [expandedRowColumnDefinitions]="expandedRowColumnDefinitions"
        [gridApiRoute]="gridApiRoute" [studentSk]="studentSk" [initialState]="initialGridState" [gridHeader]="gridHeader"
        [addButtonText]="addButtonText" [gridNestedApiRoute]="gridNestedApiRoute"
        [initialNesteState]="initialNesteState" [permissionToView]="permissionToView" [refershGrid]="refershGrid"
        [referenceData]="referenceData" (addToGrid)="addToGrid.emit($event)">
      </app-grid>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
</kendo-tilelayout>